import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { observer } from "mobx-react";
import * as React from "react";
import styled, { css } from "styled-components";
var AnimatedValuePropsBase = function(param) {
    var valueProps = param.valueProps, textColor = param.textColor, className = param.className;
    var _useState = _sliced_to_array(useState(false), 2), playingAnimation = _useState[0], setPlayingAnimation = _useState[1];
    var ref = useDoActionWhenVisible(function() {
        return setPlayingAnimation(true);
    });
    return /*#__PURE__*/ _jsx(ValuePropsContainer, {
        ref: ref,
        className: className,
        children: valueProps.map(function(param, index) {
            var title = param.title, description = param.description, ctaLink = param.ctaLink;
            return /*#__PURE__*/ _jsxs(ValueProp, {
                $index: index,
                $play: playingAnimation,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "paragraphSansMedium",
                            desktopAndAbove: "subheadingSansMedium"
                        },
                        color: textColor,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: {
                            mobileAndAbove: "1x",
                            desktopAndAbove: "2x"
                        }
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        color: textColor,
                        children: description
                    }),
                    ctaLink ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "1x"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraphSansRegular",
                                        color: textColor,
                                        children: ctaLink
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: 4
                                    }),
                                    /*#__PURE__*/ _jsx(Arrow, {
                                        direction: "right"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        tabletAndBelow: index < valueProps.length - 1 ? /*#__PURE__*/ _jsx(Spacer, {
                            size: "5x"
                        }) : undefined
                    })
                ]
            }, index);
        })
    });
};
export var AnimatedValueProps = observer(AnimatedValuePropsBase);
var FADE_IN_ANIMATION_TIME = 0.4;
var OVERLAP_OFFSET = 0.4;
/**
 * @Todd
 * We want to multiply the index * FADE_IN_ANIMATION_TIME by a number below 1
 * to cause subsequent animations to play before the previous one ends.
 * This will make the animation feel smoother and not as choppy
 */ var ValueProp = styled(Column).withConfig({
    componentId: "sc-7e8fa46f-0"
})([
    "min-width:280px;animation:fadeInDown ",
    "s ease-out forwards;opacity:0;",
    ";",
    ";@keyframes fadeInDown{from{opacity:0;transform:translateY(-30%);}to{opacity:1;transform:unset;}}"
], FADE_IN_ANIMATION_TIME, function(param) {
    var index = param.$index;
    return css([
        "",
        "{margin-left:",
        ";animation-delay:",
        "s;}"
    ], responsiveMediaQueries.desktopAndAbove, index > 0 ? getSpacing("10x") : 0, index * FADE_IN_ANIMATION_TIME * OVERLAP_OFFSET);
}, function(param) {
    var play = param.$play;
    return css([
        "animation-play-state:",
        ";"
    ], play ? "running" : "paused");
});
var ValuePropsContainer = styled(Flex).attrs({
    justify: "space-between",
    align: "flex-start",
    direction: {
        mobileAndAbove: "column",
        desktopAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-7e8fa46f-1"
})([
    "width:100%;",
    "{padding:0 114px;}"
], responsiveMediaQueries.tablet);
